import api from 'api';
import type { AccountReportSettingsPayload } from 'redux/modules/accounts.types';

export const AccountReportSettingApi = {
  get(): Promise<AccountReportSettingsPayload> {
    return api.get('account_report_setting.json');
  },
  save(accountReportSettings: AccountReportSettingsPayload): Promise<AccountReportSettingsPayload> {
    return api.put('account_report_setting.json', {
      account_report_setting: accountReportSettings,
    });
  },
};
